import React from 'react'
import styled from 'styled-components'
import ReactDropzone from 'react-dropzone'

import colors from '../_constants/colors'

import uploadInvoiceImg from '../assets/img/pre-int-icn.png'

const DropzoneComponent = styled(ReactDropzone)`
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  min-height: 200px;
  border: 5px dashed ${colors.GREY};
  border-radius: 5px;
  padding: 0.75em;
  color: #9eaeb6;
  font-size: 22px;
  cursor: pointer;
  flex-direction: column;
  text-align: center;

  &:hover {
    border-color: ${(props) => {
      return props.bordercolor || colors.FINVOICE_BLUE
    }};
  }

  img {
    height: 75px;
    margin-bottom: 10px;
  }

  .sub-text {
    font-size: 16px;
    font-weight: 300;
    margin-top: 5px;
  }
`

const Dropzone = ({ handleUpload, bordercolor, text }) => {
  return (
    <DropzoneComponent
      bordercolor={bordercolor}
      onDrop={(acceptedFiles, rejectedFiles) => handleUpload(acceptedFiles, rejectedFiles)}
    >
      <img alt="" src={uploadInvoiceImg} />
      <div className="text-content">
        <div>{text}</div>
        <div className="sub-text">Drag files here, or click to browse</div>
      </div>
    </DropzoneComponent>
  )
}

export default Dropzone
